import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo/like.svg'
import _imports_1 from '@/assets/img/logo/location.svg'


const _withScopeId = n => (_pushScopeId("data-v-194137e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col min-h-screen bg-red-5 relative" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-4 font-bold text-lg justify-between sm:mt-0 mt-4 bg-red-5" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "pl-2" }, "갤러리")
], -1))
const _hoisted_3 = { class: "grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-x-3 lg:gap-x-5 xl:gap-x-7 gap-y-3 xl:gap-y-5 2xl:gap-y-8 sm:w-[768px] w-full" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "img-container mb-3 md:mb-3.5" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "w-full h-full overflow-hidden" }
const _hoisted_8 = { class: "text-xs text-sub" }
const _hoisted_9 = { class: "h-12 pr-2 pt-2 line-clamp-2 text-xs md:text-sm text-heading text-def" }
const _hoisted_10 = { class: "text-xs text-sub flex space-x-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "mr-1"
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  class: "mr-1"
}, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "w-full justify-center items-center flex my-10"
}
const _hoisted_14 = {
  key: 1,
  class: "w-full h-32 flex justify-center items-center"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full h-40" }, null, -1))

import { ref, watch, onMounted, computed, } from 'vue';
// import { SearchApi } from '@/api/api';
import { timeForToday } from '@/utils/timeForToday';
import LoadingCircle from '@/components/UI/LoadingCircle.vue'

import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
interface Item {
    id: number;
    title: string;
    name: string;
    imgURL1: string;
    content: string;
    price: number;
    create_at: string;
    location: string;
    like_cnt: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GalleryList',
  setup(__props) {

const router = useRouter();
const store = useStore();

const clickedItem = ref<Item | null>(null); 


// 갤러리 변수
const communityList = computed(()=> store.state.community)
const isBoardLoading = ref(false);
const rst = computed(()=> store.state.currentCommunityList)

// 처음 접속 시, 전체 리스트를 출력함
onMounted(async () => {
    if(communityList.value[3].data.length === 0){
        await store.dispatch('fetchCommData', 3);
    }
    store.commit('SET_CURRENT_COMMUNITY', store.state.community[3].data)

})


const loadMore = async () => {
    isBoardLoading.value = true;
    await new Promise<void>(resolve => {
        setTimeout(() => {
            store.dispatch('fetchCommData', 3);
            resolve();
        }, 2100);
    });
    isBoardLoading.value =false;
};

// 상세보기 
const galleryDetail = (item :Item) => {
    // console.log(item.id)
    // clickedItem.value = item;
    router.push({ path: `community/${item.id}` });
};

// 상세보기 
// const postDetail = (item :Item) => {
//     clickedItem.value = item;
//     console.log(clickedItem.value)
//     router.push({ path: `reptile/detail/${item.id}` });
// };



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rst.value, (item) => {
        return (_openBlock(), _createElementBlock("li", {
          key: item.id,
          class: "group box-border overflow-hidden flex rounded-md pe-0 pb-2 lg:pb-3 flex-col items-start transition duration-200 ease-in-out transform shadow-product bg-white liWrap cursor-pointer",
          onClick: ($event: any) => (galleryDetail(item))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: item.imgURL1,
              alt: "",
              class: "bg-gray-300 object-cover w-full transition duration-200 ease-in rounded-md",
              loading: "lazy",
              decoding: "async"
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(item.name) + " · " + _toDisplayString(_unref(timeForToday)(item.create_at)), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.content), 1),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createTextVNode(" " + _toDisplayString(item.like_cnt), 1),
              _hoisted_12,
              _createTextVNode(" " + _toDisplayString(item.reply_cnt), 1)
            ])
          ])
        ], 8, _hoisted_4))
      }), 128))
    ]),
    (isBoardLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(LoadingCircle)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("button", {
            onClick: loadMore,
            class: "w-40 h-10 rounded-full border-zinc-500 border border-solid"
          }, "더보기")
        ])),
    _hoisted_15
  ]))
}
}

})